"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _sms = require("@/api/sms");
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
var _printJs = _interopRequireDefault(require("print-js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var validatePhone = function validatePhone(rule, value, callback) {
  if (!value) {
    return callback(new Error('请填写手机号'));
  } else if (!/^1[3456789]\d{9}$/.test(value)) {
    callback(new Error('手机号格式不正确!'));
  } else {
    callback();
  }
};
//修改引入打印扩展
var _default = exports.default = {
  name: 'orderSend',
  props: {
    orderId: {
      type: String,
      default: ''
    },
    expressListNormal: {
      type: Array,
      default: []
    },
    expressListElec: {
      type: Array,
      default: []
    },
    orderDetail: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      formItem: {
        deliveryType: 'express',
        expressRecordType: '1',
        expressCode: '',
        company: '',
        //快递公司
        deliveryName: '',
        deliveryTel: '',
        expressName: '',
        expressNumber: '',
        expressTempId: '',
        toAddr: '',
        toName: '',
        toTel: '',
        orderNo: ''
      },
      modals: false,
      exportTempList: [],
      tempImg: '',
      rules: {
        toName: [{
          required: true,
          message: '请输寄件人姓名',
          trigger: 'blur'
        }],
        toTel: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        toAddr: [{
          required: true,
          message: '请输入寄件人地址',
          trigger: 'blur'
        }],
        company: [{
          required: true,
          message: '请选择快递公司',
          trigger: 'change'
        }],
        expressNumber: [{
          required: true,
          message: '请输入快递单号',
          trigger: 'blur'
        }],
        expressTempId: [{
          required: true,
          message: '请选择电子面单',
          trigger: 'change'
        }],
        deliveryName: [{
          required: true,
          message: '请输入送货人姓名',
          trigger: 'blur'
        }],
        deliveryTel: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }]
      },
      expressType: 'normal',
      loading: false,
      express: [],
      //物流公司
      isEdit: false,
      //是否是编辑
      nowCompany: ''
    };
  },
  watch: {
    orderDetail: {
      handler: function handler(val) {
        if (val) {
          this.loading = true;
          this.isEdit = true;
          this.getExpressDetail(val);
        } else {
          this.isEdit = false;
          this.loading = false;
        }
      },
      immediate: false,
      deep: true
    }
  },
  mounted: function mounted() {
    this.express = this.expressListNormal;
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //物流信息详情, 快递单号，快递公司，快递公司code
    getExpressDetail: function getExpressDetail(val) {
      if (val.deliveryType === 'send') {
        this.formItem.deliveryTel = val.deliveryId;
        this.formItem.deliveryName = val.deliveryName;
      } else {
        this.formItem.expressName = val.deliveryName;
        this.formItem.expressNumber = val.deliveryId;
      }
      this.formItem.deliveryType = val.deliveryType;
      this.formItem.expressCode = val.deliveryCode;
      this.formItem.expressRecordType = val.expressRecordType;
      this.formItem.company = {
        code: val.deliveryCode,
        name: val.deliveryName
      };
      this.loading = false;
    },
    // 默认信息
    sheetInfo: function sheetInfo() {
      var _this = this;
      (0, _order.sheetInfoApi)().then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this.formItem.toAddr = res.exportToAddress || '';
                _this.formItem.toName = res.exportToName || '';
                _this.formItem.toTel = res.exportToTel || '';
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 快递公司选择
    onChangeExport: function onChangeExport(val) {
      this.formItem.expressCode = val.code;
      this.formItem.expressName = val.name;
      this.formItem.expressTempId = '';
      if (this.formItem.expressRecordType === '2') this.exportTemp(val.code);
    },
    // 电子面单模板
    exportTemp: function exportTemp(code) {
      var _this2 = this;
      (0, _sms.exportTempApi)({
        com: code
      }).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _this2.exportTempList = res.data.data || [];
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    onChangeImg: function onChangeImg(item) {
      var _this3 = this;
      this.exportTempList.map(function (i) {
        if (i.temp_id === item) _this3.tempImg = i.pic;
      });
    },
    //选择类型
    changeRadioType: function changeRadioType() {
      if (this.formItem.deliveryType === 'fictitious') {
        this.formItem.expressId = '';
        this.formItem.expressCode = '';
      }
    },
    //选择发货类型
    changeRadio: function changeRadio(o) {
      if (o === '2') {
        this.express = this.expressListElec;
      } else {
        this.express = this.expressListNormal;
      }
    },
    // 提交
    putSend: (0, _validate.Debounce)(function (name) {
      var _this4 = this;
      // 打印测试
      //this.printImg("http://api.kuaidi100.com/label/getImage/20230505/FBA3DFCE5C684CB9A13DADA8EE8357FB");
      // 正常业务中使用;
      this.formItem.orderNo = this.orderId;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          !_this4.isEdit ? (0, _order.orderSendApi)(_this4.formItem).then(function (data) {
            // data -》 label是一个网络图片地址，直接打印即可
            if (_this4.formItem.expressRecordType === '2') _this4.printImg(data.label);
            _this4.$message.success('发送货成功');
            _this4.modals = false;
            _this4.$refs[name].resetFields();
            _this4.$emit('submitFail');
          }) : (0, _order.updateTrackingNumberApi)(_this4.formItem).then(function (data) {
            _this4.$message.success('修改快递单号成功');
            _this4.modals = false;
            _this4.$refs[name].resetFields();
            _this4.$emit('submitFail');
          });
        } else {
          _this4.$message.error('请填写信息');
        }
      });
    }),
    handleClose: function handleClose() {
      this.cancel('formItem');
    },
    cancel: function cancel(name) {
      this.modals = false;
      this.$refs[name].resetFields();
      this.formItem.deliveryType = 'express';
      this.formItem.expressRecordType = '1';
    },
    //修改增加打印方法
    printImg: function printImg(url) {
      (0, _printJs.default)({
        printable: url,
        type: 'image',
        documentTitle: '快递信息',
        style: "img{\n          width: 100%;\n          height: 476px;\n        }"
      });
    }
  }
};